<template>
  <span class="countdown-component">
    <span v-show="isComplete" @click="handleClick" class="countdown-text">{{ text }}</span>
    <span v-show="!isComplete" class="countdown-seconds">{{ '验证码已发送(' + secondsRemain + 's)' }}</span>
  </span>
</template>
<script>
export default {
  name: 'c-countdown',
  props: {
    text: String,
    onClick: Function, // 需要返回promise
    onComplete: Function,
    seconds: {
      default: 59,
      type: Number
    }
  },
  data() {
    return {
      timer: null,
      isComplete: true,
      secondsRemain: this.seconds
    }
  },
  methods: {
    handleClick() {
      if (!this.onClick) {
        return ;
      }
      const result = this.onClick();
      console.log(result);
      if (result instanceof Promise) {
        result.then(res => {
          
          if (res && res.code === 0) {
            this.startCountdown()
          }
          return res
        });
      }
    },
    startCountdown() {
      this.isComplete = false
      this.timer = setInterval(() => {
        this.secondsRemain--
        if (this.secondsRemain <= 0) {
          clearInterval(this.timer)
          this.timer = null
          this.isComplete = true
          this.secondsRemain = 59
        }
      }, 1000)
    }
  }
}
</script>
<style lang="scss" scoped>
@import './style.scss';
</style>
